import moment from 'moment-wrapper'

// convert format from Moment (only for tokens from LL and LTS formats)
export const convertToDateFnsFormat = (momentFormat) => {
  const formatMapping = {
    'Y': 'y',
    'D': 'd',
    'A': 'a',
  }

  let dateFnsFormat = momentFormat

  for (const momentToken in formatMapping) {
    const dateFnsToken = formatMapping[momentToken]
    dateFnsFormat = dateFnsFormat.replaceAll(momentToken, dateFnsToken)
  }

  return dateFnsFormat
}

const getFakeOffset = (val, userTimeZone) => {
  const momentVal = moment(val)
  if (!momentVal.isValid()) {
    return null
  }

  const localOffset = momentVal.local().utcOffset()
  const userTimezoneOffset = moment.tz(val, userTimeZone).utcOffset()
  const fakeOffset = localOffset - userTimezoneOffset
  return fakeOffset
}

// React date picker uses Date object which stores specific moment in time (unix timestamp)
// and returns it in UTC or local time zone. There is no way to keep time zone in Date object.
// We need to show in date picker time in user timezone which may differ from local timezone.
// If we pass to React date picker correct Date object it will show it in local time.
// So we pass modified fake Date object which gives required time in local timezone.
//
// e.g. we need to show "06:00 UTC" time in UTC+2 timezone which is "08:00" and user's local timezone is UTC+5.
// If we pass correct Date object, user will see "11:00".
// That's why we pass a fake Date with "03:00 UTC" which is "08:00" in user local time zone.
// To return Moment object with correct time we do a reverse operation in fromInternalFakeDate.
export const toInternalFakeDate = (value, userTimeZone) => {
  if (!value) {
    return null
  }

  const val = (typeof value === 'number') ? value * 1000 : value

  const fakeOffset = getFakeOffset(val, userTimeZone)
  if (fakeOffset === null) {
    return null
  }

  const valueMoment = moment.utc(val).subtract(fakeOffset, 'minutes')
  const fakeDate = valueMoment.toDate()
  return fakeDate
}

export const fromInternalFakeDate = (fakeDate, userTimeZone) => {
  if (!fakeDate) {
    return null
  }

  const fakeOffset = getFakeOffset(fakeDate, userTimeZone)
  if (fakeOffset === null) {
    return null
  }

  const momentDate = moment.utc(fakeDate).add(fakeOffset, 'minutes').tz(userTimeZone)

  return momentDate
}
